if (typeof ProductStatus !== 'function') {
	class ProductStatus extends HTMLElement {
		constructor() {
			super();

			this.storeSelector = document.querySelector('store-selector');

			this.init();

			window.addEventListener('load', () => {
				if (this.storeSelector) {
					this.storeSelector.addEventListener('storechanged', (e) => {
						this.updateStatus();
					});
				}
			});
		}

		init() {
			this.updateStatus();
		}

		updateStatus() {
			const shipping = this.dataset.shipping === 'false' ? false : true;
			const blockedLocations =
				this.dataset.blockedLocations != '' ? JSON.parse(this.dataset.blockedLocations) : null;

			const selectedStore = localStorage.getItem('selected-store');

			const formattedLocations = [];

			if (blockedLocations) {
				for (let i = 0; i < blockedLocations.length; i++) {
					let formattedLocation = blockedLocations[i]
						.toLowerCase() // Convert to lowercase
						.replace(/ /g, '-') // Replace spaces with dashes
						.replace(/,/g, ''); // Remove commas
					formattedLocations.push(formattedLocation);
				}
			}

			if (!shipping && selectedStore === 'shipping') {
				this.classList.add('active');
				// this.updateText(`Product unavailable for ${selectedStore}`);
			} else if (formattedLocations && formattedLocations.includes(selectedStore)) {
				this.classList.add('active');
				// this.updateText(`Product unavailable for ${selectedStore}`);
			} else {
				this.classList.remove('active');
				// this.updateText('');
			}
		}

		updateText(text) {
			this.innerText = text;
		}
	}

	if (typeof customElements.get('product-status') == 'undefined') {
		customElements.define('product-status', ProductStatus);
	}
}
